import React from 'react';
import TeamMember from './TeamMember';
import './Team.css';

const Team = () => {
  return (
    <section id="Team" className="text-center bg-light">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="section-heading text-uppercase">Our Amazing Team</h2>
            <h3 className="section-subheading text-muted">Lorem ipsum dolor sit amet consectetur.</h3>
          </div>
        </div>
        <div className="row">
          <TeamMember firstName="Oscar" lastName="Stigzelius" linkedin="https://www.linkedin.com/in/oscar-stigzelius-a2808368/" img="Oscar.jpg"/>
          <TeamMember firstName="Oliver" lastName="Kaisti" linkedin="https://www.linkedin.com/in/kaistio" img="Oliver.png"/>
          <TeamMember firstName="Kasper" lastName="Keinänen" linkedin="https://www.linkedin.com/in/kasper-keinanen" img="Kasper.jpg"/>
        </div>
      </div>
    </section>
  );
};

export default Team;
